const STORAGE_KEY = 'brainscraper.sidebarCollapsed.v1';

let memory: boolean | null = null;

export function readSidebarCollapsed(): boolean {
  if (memory !== null) return memory;
  if (typeof window === 'undefined') return false;
  try {
    memory = localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    memory = false;
  }
  return memory;
}

export function writeSidebarCollapsed(collapsed: boolean): void {
  memory = collapsed;
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
  } catch {
    // ignore quota / private mode
  }
}
